import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export abstract class AuthzService {
  public abstract hasTraitement(traitement: string): Observable<boolean>;

  public hasAnyTraitement(...traitements: string[]): Observable<boolean> {
    if (!traitements?.length) {
      return of(true);
    }
    return combineLatest(traitements.map(t => this.hasTraitement(t))).pipe(
      map((hasTraitements: boolean[]) => hasTraitements.some(hasTraitement => hasTraitement)),
    )
  }

  public abstract hasAccessToModule(module: string): Observable<boolean>;

  public abstract hasAccessToAnyModule(module: string[]): Observable<boolean>;
}

/**
 * Méthodes supplémentaires pour pouvoir tester
 * les traitements dans des sélecteurs ngrx
 *
 * Traitements et modules sont retournés sous la forme de regex
 * pour qu'on puisse mettre en place un service indiquant que
 * l'utilisateur a tous les droits (cf. AuthzStubService)
 */
export abstract class AuthzNgRxAwareService extends AuthzService {
  /**
   * Retourne la liste des traitements autorisés sous
   * forme de regex
   */
   abstract lireListeTraitements(): Observable<string[]>;

  /**
   * Retourne la liste des périmètres associés
   * à l'utilisateur connecté
   */
  abstract lireListePerimetres(): Observable<string[]>;

   /**
    * Retourne la liste des modules autorisés sous
    * forme de regex
    */
    abstract lireListeModules(): Observable<string[]>;

}
